export const BREAKPOINT = {
  TABLET: 1011,
  MOBILE: 767,
}

export const PADDING = 0.1
